import * as tslib_1 from "tslib";
import { isPlatformBrowser } from "@angular/common";
import { AfterViewInit, ElementRef, OnInit, OnDestroy, } from "@angular/core";
import { Validators } from "@angular/forms";
import { NgbDatepickerConfig, NgbModal, } from "@ng-bootstrap/ng-bootstrap";
import * as $ from "jquery";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { ImageCropperComponent } from "../image-cropper/image-cropper.component";
import { PopUpComponent } from "../pop-up/pop-up.component";
import { PopUpApplicationComponent } from "../pop-up-application/pop-up-application.component";
import { PopUpWatchListComponent } from "../pop-up-watchlist/pop-up-watchlist.component";
import * as dayjs from "dayjs";
import Swal from "sweetalert2";
var ApplicationComponent = /** @class */ (function () {
    function ApplicationComponent(window, localStorage, platformId, app, router, rest, formDataService, formBuilder, seo, config, modalService, dialog, spinner, el, emailCrypto, sanitizer) {
        this.window = window;
        this.localStorage = localStorage;
        this.platformId = platformId;
        this.app = app;
        this.router = router;
        this.rest = rest;
        this.formDataService = formDataService;
        this.formBuilder = formBuilder;
        this.seo = seo;
        this.modalService = modalService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.el = el;
        this.emailCrypto = emailCrypto;
        this.sanitizer = sanitizer;
        this.NIB3 = environment.featureNIB3;
        this.FACE_API = false;
        this.initialLoadDob = true;
        this.initialLoadIssue = true;
        this.initialLoadExpire = true;
        this.underMaintainance = false;
        this.family_side_touch = false;
        this.family_member_names_touch = false;
        this.family_relation_touch = false;
        this.imageChangedEvent = "";
        this.imageChangedEventPass = "";
        this.imageChangedEventPassCover = "";
        this.croppedImage = "";
        this.croppedImagePass = "";
        this.croppedImagePassCover = "";
        this.cropperReady = false;
        this.cropperReadyPass = false;
        this.isIntendedError = false;
        this.isPhotoBigSize = false;
        this.isPassportBigSize = false;
        this.isCoverPassportBigSize = false;
        this.acceptTerm = false;
        this.checkSurname = false;
        this.isExpiredDate = false;
        this.selectedPhoneCode = "USA +1";
        this.isRequestCountry = false;
        this.hotel_doc_big_size = false;
        this.flight_doc_big_size = false;
        this.third_visa_doc_big_size = false;
        this.guarantor_visa_doc_big_size = false;
        this.hotel_warning_message = "";
        this.flight_warning_message = "";
        this.third_visa_warning_message = "";
        this.guarantor_warning_message = "";
        this.submitted = false;
        this.photo_count = 0;
        this.passport_count = 0;
        this.isPhotoSmallSize = false;
        this.isPassportSmallSize = false;
        this.isPassportCoverSmallSize = false;
        this.days = 0;
        this.except_message = "";
        this.next_2month = { year: 0, month: 0, day: 0 };
        this.minDate = { year: 0, month: 0, day: 0 };
        this.today = { year: 0, month: 0, day: 0 };
        this.citizens = "";
        this.isOrdinaryPassport = true;
        this.familySide = "";
        this.proofFileName = "";
        this.proofFileCount = 0;
        this.personRace = 0;
        this.popupCheckData = [];
        this.lastWatchlistPopupCountryId = null;
        this.expDate = [];
        this.dateBirth = [];
        this.dateIssue = [];
        this.data = {
            session_id: "",
            input_id: "",
            input_value: "",
        };
        this.imgResultBeforeCompression = "";
        this.imgResultAfterCompression = "";
        this.setFormLocalStorage = {
            photoBase64: "",
            passportBase64: "",
            photoImg: "",
            passportImg: "",
            photoImgUrl: "",
            passportImgUrl: "",
            lastName: "",
            firstName: "",
            gender: "",
            dateBirth: { year: 0, month: 0, day: 0 },
            genderSelect: "",
            countryBirth: null,
            telephone: "",
            occupation: "",
            residentialAddress: "",
            stateProvince: "",
            countryCity: null,
            passportNum: "",
            dateIssue: { year: 0, month: 0, day: 0 },
            dateExpire: { year: 0, month: 0, day: 0 },
            countryPassport: null,
            intendDate: "",
            vehicle: "",
            purposeTrip: null,
            addressDuringVisit: "",
            nextDestination: "",
            checkExpDate: dayjs().format("YYYY-MM-DD"),
        };
        this.passportImgUrl = "";
        this.photoImgUrl = "";
        this.popUpMessageHeader = "";
        this.popUpMessageBody = "";
        this.popUpMessageAlert = "";
        this.popUpMessageSubmit = "";
        this.popUpMessageEdit = "";
        this.client_email = "";
        this.filterApplication = [];
        this.showSuggestionsSurname = false;
        this.showSuggestionsFirstname = false;
        this.faceProccessing = {
            facePhotoDetect: false,
            facePassportDetect: false,
            faceMatch: false,
            faceMatchSimilar: 0,
            faceMatchMessage: "",
        };
        this.laoNewYearMsgEN = "Due to high application volume and limited processing time before the Lao New Year holiday, entry dates earlier than April 23 will no longer be selectable starting April 8. Please choose an intended date of entry on or after April 23.";
        this.laoNewYearMsgCN = "由于老挝新年假期前申请量较大且处理时间有限，自4月8日起，将无法选择4月23日之前的入境日期。请选择4月23日或之后的入境日期。";
        this.proofDocSrc = null;
        this.photoVector = "";
        this.passportVector = "";
        this.seo.addMetaTags();
        config.minDate = { year: 1900, month: 1, day: 1 };
        this.selectedLang = this.app.SelectedLang;
    }
    ApplicationComponent.prototype.onFocus = function (event) {
        if (!environment.production) {
            console.log("FOCUS", "inputId: " + event.target.id + " = " + event.target.value);
        }
        if (event.target.id === "lastName") {
            this.showSuggestionsSurname = true;
        }
        else if (event.target.id === "firstName") {
            this.showSuggestionsFirstname = true;
        }
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = event.target.id;
        this.data.input_value = event.target.value;
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
    };
    ApplicationComponent.prototype.onBlur = function (event) {
        this[event.target.id + "_touch"] = true;
        if (!environment.production)
            console.log("BLUR", "inputId: " + event.target.id + " = " + event.target.value);
        this.showSuggestionsSurname = false;
        this.showSuggestionsFirstname = false;
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = event.target.id;
        this.data.input_value = event.target.value;
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when unfocus input:", res);
        // });
    };
    ApplicationComponent.prototype.inputOnChange = function (event) {
        if (event.target.id === "tel") {
            var filterValues = this.filterValue(event.target.value);
            this.person.tel = filterValues;
        }
    };
    ApplicationComponent.prototype.filterValue = function (value) {
        return value.replace(/[^(0-9+)]+/g, "");
    };
    ApplicationComponent.prototype.convertFileToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };
    ApplicationComponent.prototype.convertBlobToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };
    ApplicationComponent.prototype.fileChangeEvent = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var base64String;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("==>", event.target.files[0]);
                        if (!(event.target.files[0].size > 10485760)) return [3 /*break*/, 1];
                        this.updateSessionTrack(event.target.id, "photo_over_10_mb");
                        this.isPhotoBigSize = true;
                        return [2 /*return*/];
                    case 1:
                        this.isPhotoBigSize = false;
                        this.imageChangedEvent = event;
                        this.photo_count = 1;
                        return [4 /*yield*/, this.convertFileToBase64(event.target.files[0])];
                    case 2:
                        base64String = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationComponent.prototype.fileChangeEventPass = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (event.target.files[0].size > 10485760) {
                    this.updateSessionTrack(event.target.id, "passport_over_10_mb");
                    this.isPhotoBigSize = true;
                    this.isPassportBigSize = true;
                    return [2 /*return*/];
                }
                else {
                    this.imgPass = event.target.files[0];
                    this.isPassportBigSize = false;
                    this.imageChangedEventPass = event;
                    this.passport_count = 1;
                }
                return [2 /*return*/];
            });
        });
    };
    ApplicationComponent.prototype.onRaceChange = function (event) {
        this.person.race = Number(event.value);
        if (event.value == 0) {
            this.person.race = 0;
            this.person.family_side = "";
            this.person.family_member_names = "";
            this.person.family_relation = "";
            this.family_side_touch = false;
            this.family_member_names_touch = false;
            this.family_relation_touch = false;
            this.person.visaType = "1";
            this.removeProofFile();
        }
        else {
            this.person.race = 304;
            this.person.visaType = "2";
        }
    };
    ApplicationComponent.prototype.proofFileChangeEvent = function (file) {
        this.proofFileCount = 1;
        var fileURL = URL.createObjectURL(file);
        this.proofFile = file;
        this.proofFileName = file.name;
        this.proofFilePreview =
            this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
    };
    ApplicationComponent.prototype.onProofDocSelected = function (event) {
        this.proofFileCount = 1;
        var file = event.target.files[0];
        if (file) {
            if (file.type === "application/pdf") {
                var fileURL = URL.createObjectURL(file);
                this.proofDocSrc =
                    this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
                this.proofFileName = file.name;
                this.proofFile = file;
            }
            else {
                this.proofFileChangeEvent(file);
            }
        }
    };
    ApplicationComponent.prototype.removeProofFile = function () {
        this.proofFile = null;
        this.proofFilePreview = "";
        this.proofFileName = "";
        this.proofFileCount = 0;
        this.proofDocSrc = null;
    };
    ApplicationComponent.prototype.onUploadProofDoc = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append("proofdoc_file", this.proofFile);
                        if (!this.proofFile) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rest.uploadProofDocService(formData)];
                    case 1:
                        result = _a.sent();
                        if (result.status == "success") {
                            this.person.proof_of_laotian = result.name;
                            this.personForm.value.proof_of_laotian = result.name;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationComponent.prototype.fileChangeEventPassCover = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.isPassportCoverBigSize = true;
            return;
        }
        else {
            this.isPassportCoverBigSize = false;
            this.imageChangedEventPassCover = event;
            this.passport_cover_count = 1;
        }
    };
    ApplicationComponent.prototype.cropperReadyLog = function () {
        console.log("Cropper ready");
    };
    ApplicationComponent.prototype.imageCropped = function (event) {
        this.croppedImage = event.base64;
    };
    ApplicationComponent.prototype.imageCroppedPass = function (event) {
        this.croppedImagePass = event.base64;
    };
    ApplicationComponent.prototype.imageCroppedPassCover = function (event) {
        this.croppedImagePassCover = event.base64;
    };
    ApplicationComponent.prototype.imageLoaded = function () {
        this.cropperReady = true;
    };
    ApplicationComponent.prototype.imageLoadedPass = function () {
        this.cropperReadyPass = true;
    };
    ApplicationComponent.prototype.imageLoadedPassCover = function () {
        this.cropperReadyPassCover = true;
    };
    ApplicationComponent.prototype.loadImageFailed = function () {
        // console.log('Load failed');
    };
    ApplicationComponent.prototype.loadImageFailedPass = function () {
        // console.log('Load failed');
    };
    ApplicationComponent.prototype.loadImageFailedPassCover = function () {
        // console.log('Load failed');
    };
    ApplicationComponent.prototype.rotateLeft = function (img) {
        console.log(this.photoCropper);
        console.log(this[img + "Cropper"]);
        this[img + "Cropper"].rotateLeft();
    };
    ApplicationComponent.prototype.rotateRight = function (img) {
        this[img + "Cropper"].rotateRight();
    };
    ApplicationComponent.prototype.flipHorizontal = function (img) {
        this[img + "Cropper"].flipHorizontal();
    };
    ApplicationComponent.prototype.flipVertical = function (img) {
        this[img + "Cropper"].flipVertical();
    };
    ApplicationComponent.prototype.verifyToken = function (credential) {
        var _this = this;
        this.rest.verifyToken(credential).subscribe(function (result) {
            if (!result["auth"] &&
                result.message === "Failed to authenticate token.") {
                _this.router.navigate(["/apply"], { replaceUrl: true });
                localStorage.removeItem(environment.localAuthenInfo);
            }
            if (!result["auth"] && result.message === "TokenExpired") {
                _this.router.navigate(["/apply"], { replaceUrl: true });
                localStorage.removeItem(environment.localAuthenInfo);
            }
            if (!result["responseStatus"]) {
                localStorage.removeItem(environment.localAuthenInfo);
                _this.router.navigate(["/apply"], { replaceUrl: true });
            }
            else {
                localStorage.setItem(environment.localAuthenInfo, JSON.stringify(result));
                console.log("Back to Applicaiton form page");
                // this.router.navigate(["/application"]);
            }
        }, function (error) {
            console.error(error);
            localStorage.removeItem(environment.localAuthenInfo);
            _this.router.navigate(["/apply"], { replaceUrl: true });
        });
    };
    ApplicationComponent.prototype.getCountryList = function () {
        var _this = this;
        this.rest.getCountry().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.mDataArrayCountry = result;
                return [2 /*return*/];
            });
        }); });
    };
    ApplicationComponent.prototype.getCountryBirthList = function () {
        var _this = this;
        this.rest.getCountryBirth().subscribe(function (result) {
            _this.mDataArrayCountryBirth = result;
        });
    };
    ApplicationComponent.prototype.getVisaTypeList = function () {
        var _this = this;
        this.rest.getVisaType().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, result];
                    case 1:
                        _a.mDataArrayVisaType = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        console.log("mDataArrayVisaType 2", this.mDataArrayVisaType);
    };
    ApplicationComponent.prototype.getPortEntryList = function () {
        var _this = this;
        this.rest.getPortEntry().subscribe(function (result) {
            _this.mDataArrayPortEntry = result;
            _this.filteredPortOfEntry = result;
        });
    };
    ApplicationComponent.prototype.getPurposeList = function () {
        var _this = this;
        this.rest.getPurpose().subscribe(function (result) {
            _this.mPurpose = result;
        });
    };
    ApplicationComponent.prototype.getCallingCodeList = function () {
        var _this = this;
        this.rest.getCallingCode().subscribe(function (result) {
            _this.mDataArrayCallingCode = result;
        });
    };
    ApplicationComponent.prototype.getExceptMessage = function () {
        var _this = this;
        this.rest.getExceptMessage().subscribe(function (result) {
            try {
                _this.except_message = result["except_message"] || "";
            }
            catch (error) {
                _this.except_message = "";
            }
        });
    };
    ApplicationComponent.prototype.getPersonInfo = function (headers) {
        this.rest.checkExistData(headers).subscribe(function (rs) { });
    };
    ApplicationComponent.prototype.deletePerson = function (application_id) {
        var id = application_id[0].application_id;
        this.rest.deletePerson(id).subscribe(function (result) { });
    };
    ApplicationComponent.prototype.readURL = function (event) {
        var _this = this;
        if (event.target.files && event.target.files[0]) {
            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                if (event.target.getAttribute("name") === "inputPassportFile") {
                    _this.person.imgPass = e.target.result;
                }
                else if (event.target.getAttribute("name") === "inputPhotoFile") {
                    _this.person.imgPhoto = e.target.result;
                }
            };
            reader.readAsDataURL(file);
        }
    };
    ApplicationComponent.prototype.save = function (form) {
        if (!form.valid) {
            return false;
        }
        this.person.first_action_date = "";
        this.formDataService.setPerson(this.person);
        this.router.navigate(["/review"]);
        return true;
    };
    ApplicationComponent.prototype.goToNext = function (form) {
        if (this.save(form)) {
            // Navigate to the work page
            this.router.navigate(["/review"]);
        }
    };
    ApplicationComponent.prototype.IntendedOnChange = function (event) {
        this.intendedDate = event;
        this.validateIntendedDate(event);
        console.log("Intended: ", event);
    };
    ApplicationComponent.prototype.validateIntendedDate = function (event) {
        if (this.expiredDate && this.intendedDate) {
            var inten = new Date(this.intendedDate.year, this.intendedDate.month - 1, this.intendedDate.day);
            var ex = new Date(this.expiredDate.year, this.expiredDate.month - 1, this.expiredDate.day);
            var intended = moment(inten);
            var expired = moment(ex);
            var diff = expired.diff(intended, "months");
            if (diff >= 6) {
                this.isIntendedError = false;
            }
            else {
                // if(this.app.SelectedLang == 'en'){
                this.intentedMessage =
                    "The passport should have minimum validity of 6 months from the date of arrival in Laos. Your expected date of entry should be within 60 days as of the date of an eVisa application. You are suggested to apply at least 5 days before your departure.";
                this.intentedMessage_cn =
                    "护照有效期不得少于6个月，将从入境老挝之日起开始计算。入境日期不得晚于申请电子签证后60天。建议您至少在出发前 5 天提出申请。";
                this.intentedMessage_fr =
                    "The passport should have minimum validity of 6 months from the date of arrival in Laos.";
                this.isIntendedError = true;
                return;
            }
        }
        if (this.intendedDate) {
            var inten = new Date(this.intendedDate.year, this.intendedDate.month - 1, this.intendedDate.day);
            var intended = moment(inten);
            var now = new Date();
            var checkintenDate = intended.diff(now, "days") + 1;
            // console.log('check if intended not more 7 day ' + checkintenDate);
            if (checkintenDate < 5) {
                // if (this.intendedDate.day > 0) {
                // if(this.app.SelectedLang == 'en'){
                this.intentedMessage =
                    "The passport should have minimum validity of 6 months from the date of arrival in Laos. Your expected date of entry should be within 60 days as of the date of an eVisa application. You are suggested to apply at least 5 days before your departure.";
                this.intentedMessage_cn =
                    "护照自抵达老挝之日起至少应有 6 个月的有效期。 您的预计入境日期应在电子签证申请之日起 60 天内。 建议您至少在出发前 5 天提出申请。";
                this.intentedMessage_fr =
                    "The passport should have minimum validity of 6 months from the date of arrival in Laos. Your expected date of entry should be within 60 days as of the date of an eVisa application. You are suggested to apply at least 5 days before your departure.";
                this.isIntendedError = true;
                // }
                return;
            }
            else {
                this.isIntendedError = false;
            }
        }
    };
    ApplicationComponent.prototype.DateBirthOnChange = function (event) {
        if (this.initialLoadDob) {
            this.initialLoadDob = false;
            return;
        }
        this.setFormLocalStorage.dateBirth = event;
        this.onSetToLocalStorage(this.setFormLocalStorage);
        this.person.DOB = event;
    };
    ApplicationComponent.prototype.ExpiredOnChange = function (event) {
        if (this.initialLoadExpire) {
            this.initialLoadExpire = false;
            return;
        }
        this.setFormLocalStorage.dateExpire = event;
        this.onSetToLocalStorage(this.setFormLocalStorage);
        this.person.expiredDate = event;
        this.expiredDate = event;
        var curent_date = new Date();
        var ex = new Date(this.expiredDate.year, this.expiredDate.month - 1, this.expiredDate.day);
        var now = moment(curent_date);
        var expired = moment(ex);
        var diff = expired.diff(now, "days");
        if (diff <= 0) {
            if (this.expiredDate.day > 0) {
                this.isExpiredDate = true;
            }
        }
        else {
            this.isExpiredDate = false;
            this.validateIntendedDate(event);
        }
    };
    ApplicationComponent.prototype.IssueOnChange = function (event) {
        if (this.initialLoadIssue) {
            this.initialLoadIssue = false;
            return;
        }
        this.issueDate = event;
        this.person.issueDate = event;
        this.setFormLocalStorage.dateIssue = event;
        this.onSetToLocalStorage(this.setFormLocalStorage);
        if (this.issueDate && this.expiredDate) {
            var curent_date = new Date();
            var ex = new Date(this.expiredDate.year + 10, this.expiredDate.month - 1, this.expiredDate.day);
            var now = moment(curent_date);
            var expired = moment(ex);
            var diff = expired.diff(now, "days");
            if (diff <= 0) {
                if (this.expiredDate.day > 0) {
                    this.isExpiredDate = true;
                }
            }
            else {
                this.isExpiredDate = false;
                this.validateIntendedDate(event);
            }
        }
    };
    ApplicationComponent.prototype.onCountryBirthChange = function (selectedId) {
        this.setFormLocalStorage.countryBirth = Number(selectedId);
        this.onSetToLocalStorage(this.setFormLocalStorage);
        console.log("Country of birth:", selectedId);
        var s = this.mDataArrayCountryBirth.find(function (x) { return x.country_id == selectedId; });
        this.person.selectedCountryBirth = s["country_name"];
        console.log("Country Birth:", s);
        // this.updateSessionTrack("countryOfBirth", `${selectedId}`);
    };
    ApplicationComponent.prototype.onPurposeChange = function (selectedId) {
        console.log("Purpose of trip: ", selectedId);
        this.setFormLocalStorage.purposeTrip = Number(selectedId);
        this.onSetToLocalStorage(this.setFormLocalStorage);
        var s = this.mPurpose.find(function (x) { return x.purpose_id == selectedId; });
        console.log(s);
        this.person.selectedPurpose = s["purpose_name"];
        // this.updateSessionTrack("purposeOfTrip", `${selectedId}`);
    };
    ApplicationComponent.prototype.onGenderChange = function (event) {
        var selectedOptions = event.target["options"];
        var selectedIndex = selectedOptions.selectedIndex;
        var selectElementText = selectedOptions[selectedIndex].text;
        this.person.selectedGender = selectElementText;
        this.setFormLocalStorage.gender = selectedOptions[selectedIndex].value;
        this.setFormLocalStorage.genderSelect = selectElementText;
        this.onSetToLocalStorage(this.setFormLocalStorage);
        console.log(event.target["options"]);
        // this.updateSessionTrack("gender", selectElementText);
    };
    ApplicationComponent.prototype.onCountryOfCityChange = function (selectedId, event, key) {
        if (key == "countryCity") {
            this.setFormLocalStorage.countryCity = Number(selectedId);
        }
        else {
            this.setFormLocalStorage.countryPassport = Number(selectedId);
        }
        this.onSetToLocalStorage(this.setFormLocalStorage);
        console.log("Data Country of City:", selectedId);
        this.updateSessionTrack("countryOfCity", "" + selectedId);
        if (selectedId !== "") {
            var ct = this.mDataArrayCountry.find(function (x) { return x.country_id == selectedId; });
            this.person.selectedCountryCity = ct["country_name"];
            this.person.selectedCountryOfPassport = ct["country_name"];
            this.citizens = ct["citizens"];
            this.days = ct["stay_day"];
            var country = this.mDataArrayCountry.find(function (x) { return x.country_id == selectedId; });
            if (country.is_except == 1) {
                event.srcElement.blur();
                event.preventDefault();
                this.openLg(this.content);
            }
            if (country.request_attach === 1) {
                this.person.is_request_doc = true;
            }
            else if (country.request_attach == 0) {
                this.person.is_request_doc = false;
            }
            // Watchlist popup: when user selects a country with watchlist flag "YES"
            // (only trigger for the citizenship/countryCity dropdown).
            var rawWatchlist = country ? country.watchlist : undefined;
            var isWatchlistYes = rawWatchlist === true ||
                rawWatchlist === 1 ||
                rawWatchlist === "1" ||
                String(rawWatchlist || "").toUpperCase() === "YES";
            var shouldTrigger = key === "countryPass";
            if (shouldTrigger) {
                var countryIdNum = Number(selectedId);
                if (!isWatchlistYes) {
                    this.lastWatchlistPopupCountryId = null;
                }
                else if (this.lastWatchlistPopupCountryId !== countryIdNum) {
                    this.lastWatchlistPopupCountryId = countryIdNum;
                    this.dialog.open(PopUpWatchListComponent, {
                        data: {
                            country_id: selectedId,
                            watchlist: country.watchlist,
                        },
                        panelClass: "mat-dialog-container",
                        disableClose: true,
                        width: "960px",
                    });
                }
            }
        }
        else {
            this.person.is_request_doc = false;
        }
        // If selected Taiwan (167), hide Boten Railway (53)
        if (selectedId == 167) {
            this.filteredPortOfEntry = this.mDataArrayPortEntry.filter(function (item) { return item.port_of_entry_id != 53; });
        }
        else {
            this.filteredPortOfEntry = this.mDataArrayPortEntry;
        }
    };
    ApplicationComponent.prototype.openLg = function (content) {
        this.modalService.open(content, { size: "lg", centered: true });
    };
    ApplicationComponent.prototype.onCountryOfPassportChange = function (selectedId, event) {
        console.log("Country Passport:", selectedId);
        if (selectedId !== "") {
            if (this.selectedCountry) {
                this.selectedCountry = selectedId;
            }
            var country = this.mDataArrayCountry.find(function (x) { return x.country_id == selectedId; });
            this.person.selectedCountryOfPassport = country["country_name"];
            if (country.is_except === 1) {
                event.srcElement.blur();
                event.preventDefault();
                this.openLg(this.content);
            }
            if (country.request_attach === 1) {
                this.person.is_request_doc = true;
            }
            else if (country.request_attach == 0) {
                this.person.is_request_doc = false;
            }
        }
        else {
            this.person.is_request_doc = false;
        }
        // If selected Taiwan (167), hide Boten Railway (53)
        if (selectedId == 167) {
            this.filteredPortOfEntry = this.mDataArrayPortEntry.filter(function (item) { return item.port_of_entry_id != 53; });
        }
        else {
            this.filteredPortOfEntry = this.mDataArrayPortEntry;
        }
    };
    ApplicationComponent.prototype.onVisaTypeChange = function (selectedId) {
        // this.updateSessionTrack("visaType", `${selectedId}`);
        var s = this.mDataArrayVisaType.find(function (x) { return x.visa_type_id == selectedId; });
        this.person.selectedvisaType = s["visa_type_name"];
        // if (this.personRace == 304) {
        //   const s: string = this.mDataArrayVisaType.find(
        //     (x: any) => x.visa_type_id == 2
        //   );
        //   this.person.visaType = "2";
        //   this.person.selectedvisaType = s["visa_type_name"];
        // } else {
        //   const s: string = this.mDataArrayVisaType.find(
        //     (x: any) => x.visa_type_id == selectedId
        //   );
        //   this.person.visaType = "1";
        //   this.person.selectedvisaType = s["visa_type_name"];
        // }
    };
    ApplicationComponent.prototype.onPortOfEntryChange = function (selectedId) {
        this.updateSessionTrack("portOfEntry", "" + selectedId);
        var s = this.mDataArrayPortEntry.find(function (x) { return x.port_of_entry_id == selectedId; });
        this.person.selectedportOfEntry = s["port_of_entry_name"];
        // Before 2023-04-07 If select Boten Railway Station, intended date must be >= 13/04/2023
        if (moment().isBefore("2023-04-07") && selectedId == 53) {
            this.minDate.year = Number(moment("2023-04-13").format("YYYY"));
            this.minDate.month = Number(moment("2023-04-13").format("MM"));
            this.minDate.day = Number(moment("2023-04-13").format("DD"));
            this.person.intendedDate = { year: 0, month: 0, day: 0 };
        }
        else {
            this.minDate.year = Number(moment().add(5, "d").format("YYYY"));
            this.minDate.month = Number(moment().add(5, "d").format("MM"));
            this.minDate.day = Number(moment().add(5, "d").format("DD"));
            // reset intended date
            this.person.intendedDate = { year: 0, month: 0, day: 0 };
        }
    };
    ApplicationComponent.prototype.onSubmit = function (form) {
        console.log("Person Form:", this.person);
        this.submitted = true;
        if (!this.checkSurname && this.person.lastName === "") {
            return form.invalid;
        }
        if (!this.person.imgPhotoName) {
            this.custImage.imgPhoto = null;
            return;
        }
        if (!this.person.imgPassName) {
            this.custImage.imgPass = null;
            return;
        }
        if (!this.person.countryCity) {
            return;
        }
        if (this.person.is_request_doc === true) {
            if (this.person.hotel_doc === "" || this.hotel_doc_big_size === true) {
                return;
            }
            if (this.person.flight_doc === "" || this.flight_doc_big_size === true) {
                return;
            }
            if (this.person.third_visa_doc === "" ||
                this.third_visa_doc_big_size === true) {
                return;
            }
            if (this.person.hotel_doc === "" ||
                this.guarantor_visa_doc_big_size === true) {
                return;
            }
            if (this.person.bank_statement_doc === "" ||
                this.bank_statement_doc_big_size === true) {
                return;
            }
        }
        else if (this.save(form)) {
            this.router.navigate(["/review"]);
            this.clearFaceProcessing();
        }
    };
    ApplicationComponent.prototype.checkAccept = function () {
        this.acceptTerm = !this.acceptTerm;
    };
    ApplicationComponent.prototype.onCheckSurname = function () {
        this.checkSurname = !this.checkSurname;
    };
    ApplicationComponent.prototype.onUploadPhotoImage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.spinner.show();
                this.custImage.imgPhoto = this.croppedImage;
                formData = new FormData();
                formData.append("upload_file_photo", this.croppedImage);
                formData.append("version", "2");
                formData.append("passportVector", this.passportVector);
                this.rest.uploadPhotoFile(formData).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        this.spinner.hide();
                        if (result.face) {
                            this.FACE_API = true;
                            if (result.face.faceDetect) {
                                this.faceProccessing.facePhotoDetect = true;
                                this.photoVector = result.face.vector;
                            }
                            else {
                                this.faceProccessing.facePhotoDetect = false;
                            }
                            this.onSetFaceProcessing();
                        }
                        else {
                            this.FACE_API = false;
                        }
                        if (result.compareResult) {
                            this.FACE_API = true;
                            if (!result.compareResult.isMatch) {
                                this.faceProccessing.faceMatch = false;
                                this.faceProccessing.faceMatchMessage =
                                    "Photo is not match with photo in passport";
                            }
                            else {
                                this.faceProccessing.faceMatch = true;
                                this.faceProccessing.faceMatchSimilar = Math.floor(result.compareResult.similar_percent);
                            }
                            this.onSetFaceProcessing();
                        }
                        else {
                            this.FACE_API = false;
                        }
                        fetch(environment.node_mrz_url + "/v1/mrz/upload_photo", {
                            method: "POST",
                            body: formData,
                        }).catch(function (error) {
                            console.log(error);
                        });
                        this.person.imgPhotoName = result.name;
                        this.setFormLocalStorage.photoImg = result.name;
                        this.photoImgUrl = environment.node_image_url + "/photo/" + dayjs().format("YYYYMMDD") + "/" + result.name;
                        this.setFormLocalStorage.photoImgUrl = environment.node_image_url + "/photo/" + dayjs().format("YYYYMMDD") + "/" + result.name;
                        this.onSetToLocalStorage(this.setFormLocalStorage);
                        // this.croppedImage = "";
                        this.imageChangedEvent = "";
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ApplicationComponent.prototype.onUploadPassportImage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.spinner.show();
                this.custImage.imgPass = this.croppedImagePass;
                this.mrzPass = this.imgPass;
                formData = new FormData();
                formData.append("upload_file_passport", this.custImage.imgPass);
                formData.append("photoVector", this.photoVector);
                this.rest.uploadPassportFile(formData).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        this.spinner.hide();
                        this.person.imgPassName = result.name;
                        this.setFormLocalStorage.passportImg = result.name;
                        fetch(environment.node_mrz_url + "/v1/mrz/upload_passport", {
                            method: "POST",
                            body: formData,
                        }).catch(function (error) {
                            console.log(error);
                        });
                        this.setFormLocalStorage.passportImgUrl = environment.node_image_url + "/passport/" + dayjs().format("YYYYMMDD") + "/" + result.name;
                        this.onSetToLocalStorage(this.setFormLocalStorage);
                        this.passportImgUrl = environment.node_image_url + "/passport/" + dayjs().format("YYYYMMDD") + "/" + result.name;
                        // this.croppedImagePass = "";
                        this.imageChangedEventPass = "";
                        // this.cropperReadyPass = false;
                        // setTimeout(() => {
                        //   this.updateSessionTrack("upload_passport", "upload_passport_success");
                        // }, 1500);
                        if (result.face) {
                            this.FACE_API = true;
                            if (result.face.faceDetect) {
                                this.faceProccessing.facePassportDetect = true;
                                this.passportVector = result.face.vector;
                            }
                            else {
                                this.faceProccessing.facePassportDetect = false;
                            }
                            this.onSetFaceProcessing();
                        }
                        else {
                            this.FACE_API = false;
                        }
                        if (result.compareResult) {
                            this.FACE_API = true;
                            if (!result.compareResult.isMatch) {
                                this.faceProccessing.faceMatch = false;
                                this.faceProccessing.faceMatchMessage =
                                    "Photo is not match with photo in passport";
                            }
                            else {
                                this.faceProccessing.faceMatch = true;
                                this.faceProccessing.faceMatchSimilar = Math.floor(result.compareResult.similar_percent);
                            }
                            this.onSetFaceProcessing();
                        }
                        else {
                            this.FACE_API = false;
                        }
                        if (result.mrz !== null) {
                            this.person.mrz_response = result.mrz;
                            if (result.mrz.status == "success") {
                                this.mrzData = result.mrz.data.passport;
                                if (this.mrzData.lastName)
                                    this.person.lastName = this.mrzData.lastName;
                                this.setFormLocalStorage.lastName = this.mrzData.lastName;
                                if (this.mrzData.firstName)
                                    this.person.firstName = this.mrzData.firstName;
                                this.setFormLocalStorage.firstName = this.mrzData.firstName;
                                if (this.mrzData.passportNumber)
                                    this.person.passportNumber = this.mrzData.passportNumber;
                                this.setFormLocalStorage.passportNum = this.mrzData.passportNumber;
                                this.onGetApplicationRedisByPassportNum(this.mrzData.passportNumber);
                                if (this.mrzData.sex)
                                    this.person.gender = ("" + this.mrzData.sex).toLowerCase();
                                if (result.mrz.data.passport)
                                    this.expDate = result.mrz.data.passport.expirationDate.split("-");
                                if (this.mrzData.birthDate)
                                    this.dateBirth = this.mrzData.birthDate.split("-");
                                if (this.mrzData.countryOfCitizenshipId)
                                    this.person.countryCity = this.mrzData.countryOfCitizenshipId;
                                if (this.mrzData.countryOfPassportId)
                                    this.person.countryOfPassport = this.mrzData.countryOfPassportId;
                                this.ExpiredOnChange({
                                    year: parseInt(this.expDate[0]),
                                    month: parseInt(this.expDate[1]),
                                    day: parseInt(this.expDate[2]),
                                });
                                this.DateBirthOnChange({
                                    year: parseInt(this.dateBirth[0]),
                                    month: parseInt(this.dateBirth[1]),
                                    day: parseInt(this.dateBirth[2]),
                                });
                                this.onCountryOfCityChange(this.mrzData.countryOfCitizenshipId, "", "nothing");
                                this.onCountryOfPassportChange(this.mrzData.countryOfPassportId, "");
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ApplicationComponent.prototype.onUploadPassportCoverImage = function () {
        var _this = this;
        this.custImage.imgCover = this.croppedImagePassCover;
        var event = this.imageChangedEventPassCover;
        var formData = new FormData();
        formData.append("upload_file_passport_cover", this.custImage.imgCover);
        this.rest.uploadPassportCoverFile(formData).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.person;
                        return [4 /*yield*/, result[0].name];
                    case 1:
                        _a.imgCoverName = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ApplicationComponent.prototype.onFileHotelChanged = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.hotel_doc_big_size = true;
        }
        else {
            this.hotel_doc_big_size = false;
            this.selectedFile = event.target.files[0];
            this.person.hotel_doc = event.target.files[0].name;
            // console.log(this.person.hotel_doc);
            this.onUpload();
        }
    };
    ApplicationComponent.prototype.onFileFlightChanged = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.flight_doc_big_size = true;
        }
        else {
            this.flight_doc_big_size = false;
            this.selectedFileFlight = event.target.files[0];
            this.onUploadFlight();
        }
    };
    ApplicationComponent.prototype.onFileThirdVisaChanged = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.third_visa_doc_big_size = true;
        }
        else {
            this.third_visa_doc_big_size = false;
            this.selectedFileThirdVisa = event.target.files[0];
            this.person.third_visa_doc = event.target.files[0].name;
            this.onUploadThirdVisa();
        }
    };
    ApplicationComponent.prototype.onFileGuarantorInputUploadChanged = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.guarantor_visa_doc_big_size = true;
        }
        else {
            this.guarantor_visa_doc_big_size = false;
            this.selectedFileGuarantor = event.target.files[0];
            this.person.guarantor_doc = event.target.files[0].name;
            this.onUploadGuarantor();
        }
    };
    ApplicationComponent.prototype.onFileBankStatementChanged = function (event) {
        if (event.target.files[0].size > 2097152) {
            this.bank_statement_doc_big_size = true;
        }
        else {
            this.bank_statement_doc_big_size = false;
            this.selectedFileBankStatement = event.target.files[0];
            this.person.bank_statement_doc = event.target.files[0].name;
            this.onUploadBankStatement();
        }
    };
    ApplicationComponent.prototype.onUpload = function () {
        var _this = this;
        var uploadData = new FormData();
        uploadData.append("hotel_file", this.selectedFile, this.selectedFile.name);
        this.rest.uploadHoteldoc(uploadData).subscribe(function (result) {
            _this.person.hotel_doc = result.name;
        });
    };
    ApplicationComponent.prototype.onUploadFlight = function () {
        var _this = this;
        var uploadData = new FormData();
        uploadData.append("flight_file", this.selectedFileFlight, this.selectedFileFlight.name);
        this.rest.uploadFlightdoc(uploadData).subscribe(function (result) {
            _this.person.flight_doc = result.name;
        });
    };
    ApplicationComponent.prototype.onUploadThirdVisa = function () {
        var _this = this;
        var uploadData = new FormData();
        uploadData.append("third_visa_file", this.selectedFileThirdVisa, this.selectedFileThirdVisa.name);
        this.rest.uploadThirdVisadoc(uploadData).subscribe(function (result) {
            _this.person.third_visa_doc = result.name;
        });
    };
    ApplicationComponent.prototype.onUploadGuarantor = function () {
        var _this = this;
        var uploadData = new FormData();
        uploadData.append("guarantor_file", this.selectedFileGuarantor, this.selectedFileGuarantor.name);
        this.rest.uploadGuarantordoc(uploadData).subscribe(function (result) {
            _this.person.guarantor_doc = result.name;
        });
    };
    ApplicationComponent.prototype.onUploadBankStatement = function () {
        var _this = this;
        var uploadData = new FormData();
        uploadData.append("bank_statement_file", this.selectedFileBankStatement, this.selectedFileBankStatement.name);
        this.rest.uploadBankStatementdoc(uploadData).subscribe(function (result) {
            _this.person.bank_statement_doc = result.name;
        });
    };
    Object.defineProperty(ApplicationComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.personForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    ApplicationComponent.prototype.getAuthInfo = function () {
        if (!isPlatformBrowser(this.platformId)) {
            return null;
        }
        try {
            var raw = this.localStorage.getItem(environment.localAuthenInfo);
            if (raw && raw !== "undefined" && raw !== "null") {
                return JSON.parse(raw);
            }
        }
        catch (e) {
            console.warn("Failed to parse localAuthenInfo:", e);
        }
        return null;
    };
    ApplicationComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.getApplicationFromRedis();
        console.log("Person Form:", this.person);
        var authInfo = this.getAuthInfo();
        var checkValidDate = this.setFormLocalStorage && this.setFormLocalStorage.checkExpDate;
        setTimeout(function () {
            if (!_this.setFormLocalStorage) {
                return;
            }
            var currentDate = dayjs();
            var dayDiff = currentDate.diff(checkValidDate, "days");
            if (dayDiff > 7) {
                _this.localStorage.removeItem("previousData");
            }
            else {
                _this.person.lastName = _this.setFormLocalStorage.lastName;
                _this.person.firstName = _this.setFormLocalStorage.firstName;
                _this.person.selectedGender = _this.setFormLocalStorage.genderSelect;
                _this.person.gender = _this.setFormLocalStorage.gender;
                // this.custImage.imgPhoto = this.setFormLocalStorage.photoBase64;
                // this.custImage.imgPass = this.setFormLocalStorage.passportBase64;
                // this.reUploadPhoto(this.custImage.imgPhoto);
                // this.reUploadPassport(this.custImage.imgPass);
                _this.person.imgPhotoName = _this.setFormLocalStorage.photoImg;
                _this.person.imgPassName = _this.setFormLocalStorage.passportImg;
                _this.passportImgUrl = _this.setFormLocalStorage.passportImgUrl;
                _this.photoImgUrl = _this.setFormLocalStorage.photoImgUrl;
                _this.DateBirthOnChange(_this.setFormLocalStorage.dateBirth);
                _this.IssueOnChange(_this.setFormLocalStorage.dateIssue);
                _this.ExpiredOnChange(_this.setFormLocalStorage.dateExpire);
                _this.person.tel = _this.setFormLocalStorage.telephone;
                _this.person.occupation = _this.setFormLocalStorage.occupation;
                _this.person.resAddress = _this.setFormLocalStorage.residentialAddress;
                _this.person.province = _this.setFormLocalStorage.stateProvince;
                _this.person.issueDate = _this.setFormLocalStorage.dateIssue;
                _this.person.passportNumber = _this.setFormLocalStorage.passportNum;
                _this.person.vehicle = _this.setFormLocalStorage.vehicle;
                _this.person.addressDuringVisit =
                    _this.setFormLocalStorage.addressDuringVisit;
                _this.person.next_destination = _this.setFormLocalStorage.nextDestination;
            }
        }, 2000);
        if (authInfo) {
            this.person.token = authInfo.token;
            this.verifyToken(authInfo.token);
            this.getPersonInfo(authInfo.token);
            this.getCountryList();
            this.getCountryBirthList();
            this.getVisaTypeList();
            this.getPortEntryList();
            this.getCallingCodeList();
            this.getPurposeList();
            this.getExceptMessage();
            var localAuth = this.localStorage.getItem("localAuthenInfo");
            setTimeout(function () {
                if (!_this.setFormLocalStorage) {
                    return;
                }
                _this.person.DOB = _this.setFormLocalStorage.dateBirth;
                if (_this.setFormLocalStorage.countryBirth !== null && _this.mDataArrayCountryBirth) {
                    var s = _this.mDataArrayCountryBirth.find(function (x) { return x.country_id === _this.setFormLocalStorage.countryBirth; });
                    if (s) {
                        _this.person.countryBirth = s["country_id"];
                        _this.person.selectedCountryBirth = s["country_name"];
                    }
                }
                if (_this.setFormLocalStorage.countryCity !== null && _this.mDataArrayCountry) {
                    var s = _this.mDataArrayCountry.find(function (x) { return x.country_id === _this.setFormLocalStorage.countryCity; });
                    if (s) {
                        _this.person.countryCity = s["country_id"];
                        _this.person.selectedCountryCity = s["country_name"];
                    }
                }
                if (_this.setFormLocalStorage.countryPassport !== null && _this.mDataArrayCountry) {
                    var s = _this.mDataArrayCountry.find(function (x) {
                        return x.country_id === _this.setFormLocalStorage.countryPassport;
                    });
                    if (s) {
                        _this.person.countryOfPassport = s["country_id"];
                        _this.person.selectedCountryOfPassport = s["country_name"];
                    }
                }
                if (_this.setFormLocalStorage.purposeTrip !== null && _this.mPurpose) {
                    var s = _this.mPurpose.find(function (x) { return x.purpose_id === _this.setFormLocalStorage.purposeTrip; });
                    if (s) {
                        _this.person.purposeOfTrip = s["purpose_id"];
                        _this.person.selectedPurpose = s["purpose_name"];
                    }
                }
                if (_this.person.countryCity == "167" ||
                    _this.person.countryOfPassport == "167") {
                    _this.filteredPortOfEntry = _this.mDataArrayPortEntry ? _this.mDataArrayPortEntry.filter(function (item) { return item.port_of_entry_id != 53; }) : [];
                }
                else {
                    _this.filteredPortOfEntry = _this.mDataArrayPortEntry;
                }
            }, 3000);
            if (localAuth && localAuth !== "null" && localAuth !== "undefined") {
                try {
                    var authUser = JSON.parse(localAuth);
                    var token = authUser["token"];
                    if (token && token.includes(".")) {
                        var payload = token.split(".")[1];
                        var payloadObj = JSON.parse(atob(payload))["email"];
                    }
                }
                catch (e) {
                    console.warn("Failed to parse localAuth payload:", e);
                }
            }
        }
        else {
            this.router.navigate(["apply"]);
        }
    };
    // @TraceMethodDecorator()
    ApplicationComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.intervalId = setInterval(function () {
            var authInfo = _this.getAuthInfo();
            if (authInfo && authInfo.token) {
                _this.verifyToken(authInfo.token);
            }
        }, 300 * 1000);
        this.onLoadFaceProcessing();
        this.sessionId = localStorage.getItem("session_id");
        this.onSetDateLaoNewYear();
        this.client_email = this.localStorage.getItem("email");
        try {
            var prevDataRaw = this.localStorage.getItem("previousData");
            if (prevDataRaw && prevDataRaw !== "undefined" && prevDataRaw !== "null") {
                var decrypted = this.emailCrypto.decryptFormValue(prevDataRaw);
                if (decrypted) {
                    this.setFormLocalStorage = JSON.parse(decrypted);
                }
            }
        }
        catch (e) {
            console.warn("Failed to load previousData:", e);
        }
        //  this.minDate.year = Number(moment().add(5, "d").format("YYYY"));
        //  this.minDate.month = Number(moment().add(5, "d").format("MM"));
        //  this.minDate.day = Number(moment().add(5, "d").format("DD"));
        this.rest.getMaintainance().subscribe(function (res) {
            if (res.status == "success") {
                _this.underMaintainance = true;
                _this.router.navigate(["/apply"]);
            }
            console.log(_this.underMaintainance);
        });
        this.today.year = Number(moment().format("YYYY"));
        this.today.month = Number(moment().format("MM"));
        this.today.day = Number(moment().format("DD"));
        this.next_2month.year = Number(moment().add(60, "d").format("YYYY"));
        this.next_2month.month = Number(moment().add(60, "d").format("MM"));
        this.next_2month.day = Number(moment().add(60, "d").format("DD"));
        if (this.selectedLang == "en") {
            this.popUpMessageHeader =
                "You did not fill in the 'Surname' field. Please confirm if you do not have a surname. Otherwise, go back and enter your surname before submitting";
            this.popUpMessageBody =
                "I confirm that my passport does not have a surname.";
            this.popUpMessageAlert = "Please check the confirm box to continue";
            this.popUpMessageSubmit = "Confirm & Submit";
            this.popUpMessageEdit = "Go Back & Edit";
        }
        else {
            this.popUpMessageHeader =
                "您未填写'姓氏'栏。请确认您是否没有姓氏。否则，请返回并在提交前输入您的姓氏。";
            this.popUpMessageBody = "我确认我的护照上没有姓氏。";
            this.popUpMessageAlert = "请勾选确认框以继续";
            this.popUpMessageSubmit = "确认并提交";
            this.popUpMessageEdit = "返回并编辑";
        }
        this.personForm = this.formBuilder.group({
            firstName: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z ,-.']*")],
            ],
            lastName: ["", [Validators.pattern("[a-zA-Z ,-.']*")]],
            gender: ["", [Validators.required]],
            DOB: ["", [Validators.required]],
            countryBirth: ["", [Validators.required]],
            tel: ["", [Validators.required, Validators.pattern("^[0-9+]{6}[0-9]+$")]],
            occupation: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9 ,]*")],
            ],
            resAddress: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9 ',.#]*")],
            ],
            province: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9 ,]*")],
            ],
            countryCity: ["", [Validators.required]],
            next_destination: [" ", [Validators.pattern("[a-zA-Z0-9 ,]*")]],
            passportNumber: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9]*")],
            ],
            issueDate: ["", [Validators.required]],
            expiredDate: ["", [Validators.required]],
            countryOfPassport: ["", [Validators.required]],
            visaType: ["1", [Validators.required]],
            intendedDate: ["", [Validators.required]],
            vehicle: ["", [Validators.pattern("[a-zA-Z0-9 ,]*")]],
            purposeOfTrip: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9 ,]*")],
            ],
            addressDuringVisit: [
                "",
                [Validators.required, Validators.pattern("[a-zA-Z0-9 ',]*")],
            ],
            acceptTerm: ["", [Validators.required]],
            myfileFlight: ["", []],
            myfileHotel: ["", []],
            ThirdCountryVisa: ["", []],
            guarantor: ["", []],
            bank_statement: ["", []],
        });
        // alert(this.cookieService.get('p_id'));
        this.person = this.formDataService.getFormData();
        this.custImage = this.formDataService.getFormData();
        this.person.currentActiveForm = "1";
        $(document).ready(function () {
            $("#warningUploadPassport").hide();
            $("#warningUploadPhoto").hide();
            $("#btnContinue").click(function () {
                if ($("#inputPassportFile")[0].files.length === 0) {
                    $("#warningUploadPassport").show();
                }
                if ($("#inputPhotoFile")[0].files.length === 0) {
                    $("#warningUploadPhoto").show();
                }
            });
            $("#btnshowModalPassport").click(function () {
                $("#warningUploadPassport").hide();
            });
            $("#btnshowModalPhoto").click(function () {
                $("#warningUploadPhoto").hide();
            });
            $("#btnshowModalPassportCover").click(function () {
                $("#warningUploadPassportCover").hide();
            });
        });
    };
    ApplicationComponent.prototype.ngOnDestroy = function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            console.log("Interval cleared.");
        }
    };
    ApplicationComponent.prototype.onActivate = function (event) {
        this.window.scroll(0, 0);
    };
    ApplicationComponent.prototype.scrollToFirstInvalidControl = function () {
        var firstInvalidControl = this.el.nativeElement.querySelector("form .ng-invalid");
        // firstInvalidControl.focus(); //without smooth behavior
        window.scroll({
            top: this.getTopOffset(firstInvalidControl),
            left: 0,
            behavior: "smooth",
        });
    };
    ApplicationComponent.prototype.onGetApplicationRedisByPassportNum = function (passportNum) {
        var _this = this;
        var mockData = {
            country_birth_id: 17,
            country_of_city: 17,
            country_of_passport: 17,
            dob: "1981-7-14",
            expired_date: "2027-12-31",
            first_name: "ANOUKONE",
            gender: "female",
            issue_date: "2024-7-15",
            last_name: "SMITH",
            occupation: "fghjkl",
            passport_number: "666614556",
            residential_address: "ujik",
            state_province: "hkhnjk",
            telephone: "7894652485",
        };
        this.rest
            .getApplicationPreviousVisitRedis(this.emailCrypto.decryptEmailSimple(this.client_email), passportNum + "-passport")
            .subscribe(function (res) {
            _this.dialog
                .open(PopUpApplicationComponent, {
                data: res.results[0].value,
                // data: mockData,
                panelClass: "mat-popup-container",
            })
                .afterClosed()
                .subscribe(function (confirm) {
                console.log("Confirm Applying data: ");
                if (confirm == "continue") {
                    _this.onSelectItem(res.results[0].value);
                }
            });
        });
    };
    ApplicationComponent.prototype.getApplicationFromRedis = function () {
        var _this = this;
        this.rest
            .getApplicationPreviousVisitRedis(this.emailCrypto.decryptEmailSimple(this.client_email), "")
            .subscribe(function (res) {
            _this.filterApplication = res.results;
        });
    };
    ApplicationComponent.prototype.onSelectItem = function (data) {
        console.log("Data from select item: ", data);
        // PSERSON FORM
        this.person.lastName = data.last_name;
        this.person.firstName = data.first_name;
        this.person.gender = data.gender;
        this.person.occupation = data.occupation;
        this.person.passportNumber = data.passport_number;
        this.person.resAddress = data.residential_address;
        this.person.province = data.state_province;
        this.person.tel = data.telephone;
        this.person.countryBirth = data.country_birth_id;
        this.onCountryBirthChange(data.country_birth_id);
        this.person.countryOfPassport = data.country_of_passport;
        this.onCountryOfPassportChange(data.country_of_passport, "");
        this.person.countryCity = data.country_of_city;
        this.onCountryOfCityChange(data.country_of_city, "", "nothing");
        this.expDate = data.expired_date.split("-");
        this.dateBirth = data.dob.split("-");
        this.dateIssue = data.issue_date.split("-");
        this.ExpiredOnChange({
            year: parseInt(this.expDate[0]),
            month: parseInt(this.expDate[1]),
            day: parseInt(this.expDate[2]),
        });
        this.DateBirthOnChange({
            year: parseInt(this.dateBirth[0]),
            month: parseInt(this.dateBirth[1]),
            day: parseInt(this.dateBirth[2]),
        });
        this.IssueOnChange({
            year: parseInt(this.dateIssue[0]),
            month: parseInt(this.dateIssue[1]),
            day: parseInt(this.dateIssue[2]),
        });
        //
        // SET TO LocalStorage
        this.setFormLocalStorage.lastName = data.last_name;
        this.setFormLocalStorage.firstName = data.first_name;
        this.setFormLocalStorage.gender = data.gender;
        this.setFormLocalStorage.occupation = data.occupation;
        this.setFormLocalStorage.passportNum = data.passport_number;
        this.setFormLocalStorage.residentialAddress = data.residential_address;
        this.setFormLocalStorage.stateProvince = data.state_province;
        this.setFormLocalStorage.telephone = data.telephone;
        this.setFormLocalStorage.countryBirth = data.country_birth_id;
        this.setFormLocalStorage.countryPassport = data.country_of_passport;
        this.setFormLocalStorage.countryCity = data.country_of_city;
        this.onSetToLocalStorage(this.setFormLocalStorage);
    };
    ApplicationComponent.prototype.getTopOffset = function (controlEl) {
        var labelOffset = 150;
        return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
    };
    ApplicationComponent.prototype.checkDuplicate = function () {
        var _this = this;
        var authInfo = this.getAuthInfo();
        if (this.personForm.invalid) {
            this.personForm.markAllAsTouched();
            this.scrollToFirstInvalidControl();
        }
        var _a = this.formDataService.getPerson(), passportNumber = _a.passportNumber, countryOfPassport = _a.countryOfPassport;
        if (authInfo && authInfo.token) {
            this.verifyToken(authInfo.token);
        }
        this.rest
            .CheckDuplicate({
            passportNumber: passportNumber,
            countryOfPassport: countryOfPassport,
        })
            .subscribe(function (result) {
            if (result.status == "success") {
                _this.onSubmit(_this.personForm);
                _this.data.session_id = _this.localStorage.getItem("session_id");
                _this.data.input_id = "NextToReview";
                _this.data.input_value = "continue_to_review";
                // this.rest.updateUserSession(this.data).subscribe((res) => {
                //   console.log("Result Update Session:", res);
                // });
            }
            else {
                _this.dialog
                    .open(PopUpComponent, {
                    data: result.data,
                    panelClass: "mat-popup-container",
                })
                    .afterClosed()
                    .subscribe(function (confirm) {
                    console.log("Confirm duplicate:", confirm);
                    if (confirm == "continue") {
                        _this.onSubmit(_this.personForm);
                        _this.data.session_id = _this.localStorage.getItem("session_id");
                        _this.data.input_id = "NextToReview";
                        _this.data.input_value = "continue_to_review";
                        // this.rest.updateUserSession(this.data).subscribe((res) => {
                        //   console.log("Result Update Session:", res);
                        // });
                    }
                });
            }
        });
    };
    ApplicationComponent.prototype.updateSessionTrack = function (input, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    ApplicationComponent.prototype.clickPopUp = function () {
        var data = [
            {
                application_id: "KK14OMT",
                country_of_passport: 10,
                created_date: "2024-01-25T04:49:27.000Z",
                expired_date: "2028-03-11T17:00:00.000Z",
                intended_date: "2024-01-30T17:00:00.000Z",
                issue_date: "2024-01-24T17:00:00.000Z",
                passport_number: "MEQU2875497",
                status: "Active",
                visa_status: "Pending",
            },
            {
                application_id: "KK14OMT",
                country_of_passport: 10,
                created_date: "2024-01-25T04:49:27.000Z",
                expired_date: "2028-03-11T17:00:00.000Z",
                intended_date: "2024-01-30T17:00:00.000Z",
                issue_date: "2024-01-24T17:00:00.000Z",
                passport_number: "MEQU2875497",
                status: "Active",
                visa_status: "Pending",
            },
        ];
        console.log("Click me!");
        // this.dialog
        //   .open(PopUpComponent, {
        //     data,
        //     panelClass: "mat-dialog-container",
        //   })
        //   .afterClosed()
        //   .subscribe((confirm) => {
        //     console.log("Confirm duplicate:", confirm);
        //   });
        this.dialog.open(PopUpWatchListComponent, {
            data: {
                country_id: 1,
                watchlist: 1,
            },
            panelClass: "mat-dialog-container",
            disableClose: true,
            width: "960px",
        });
    };
    ApplicationComponent.prototype.onSetDateLaoNewYear = function () {
        var dateAdd = {
            "2026-04-09": 13,
            "2026-04-10": 12,
            "2026-04-11": 11,
            "2026-04-12": 10,
            "2026-04-13": 9,
            "2026-04-14": 8,
            "2026-04-15": 7,
            "2026-04-16": 6,
            "2026-04-17": 5,
        }[moment().format("YYYY-MM-DD")] || 5;
        console.log("Date ADD: ", dateAdd);
        var newDate = moment().add(dateAdd, "days");
        this.minDate.year = Number(newDate.format("YYYY"));
        this.minDate.month = Number(newDate.format("MM"));
        this.minDate.day = Number(newDate.format("DD"));
        // const currentDate = moment().add(5, "days");
        // const restrictedStart = moment("2025-04-08");
        // const restrictedEnd = moment("2025-04-23");
        // const allowedStartDate = moment("2025-04-29");
        // Set the minimum date based on the current date and restrictions
        // const minDate = currentDate.isBetween(
        //   restrictedStart,
        //   restrictedEnd,
        //   null,
        //   "[]"
        // )
        //   ? allowedStartDate
        //   : currentDate;
        // console.log("Min Date Select: ", minDate);
        // Assigning the restricted or unrestricted minDate to this.minDate
        // Object.assign(this.minDate, {
        //   year: Number(minDate.format("YYYY")),
        //   month: Number(minDate.format("MM")),
        //   day: Number(minDate.format("DD")),
        // });
    };
    ApplicationComponent.prototype.onSetUnfinishedForm = function (event, key) {
        if (key == "firstName") {
            this.setFormLocalStorage.firstName = event.target.value;
        }
        else if (key == "lastName") {
            this.setFormLocalStorage.lastName = event.target.value;
        }
        else if (key == "telephone") {
            this.setFormLocalStorage.telephone = event.target.value;
        }
        else if (key == "occupation") {
            this.setFormLocalStorage.occupation = event.target.value;
        }
        else if (key == "resAddress") {
            this.setFormLocalStorage.residentialAddress = event.target.value;
        }
        else if (key == "province") {
            this.setFormLocalStorage.stateProvince = event.target.value;
        }
        else if (key == "passportNo") {
            this.setFormLocalStorage.passportNum = event.target.value;
        }
        else if (key == "vehicle") {
            this.setFormLocalStorage.vehicle = event.target.value;
        }
        else if (key == "addrDuringVisit") {
            this.setFormLocalStorage.addressDuringVisit = event.target.value;
        }
        else if (key == "nextDestination") {
            this.setFormLocalStorage.nextDestination = event.target.value;
        }
        this.onSetToLocalStorage(this.setFormLocalStorage);
    };
    ApplicationComponent.prototype.onValueChange = function (event, type_input) {
        var _this = this;
        var value = event.target.value;
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(function () {
            console.log("Search:", value);
            _this.rest
                .getApplicationPreviousVisitRedis(_this.emailCrypto.decryptEmailSimple(_this.client_email), value + "-" + type_input)
                .subscribe(function (res) {
                _this.filterApplication = res.results;
            });
        }, 2000);
    };
    ApplicationComponent.prototype.onSetToLocalStorage = function (data) {
        this.localStorage.setItem("previousData", this.emailCrypto.encryptEmailSimple(JSON.stringify(data)));
    };
    ApplicationComponent.prototype.reUploadPhoto = function (base64) {
        var _this = this;
        var formData = new FormData();
        formData.append("upload_file_photo", base64);
        formData.append("version", "2");
        this.rest.uploadPhotoFile(formData).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (Array.isArray(result)) {
                    this.person.imgPhotoName = result[0].name;
                }
                else {
                    this.person.imgPhotoName = result.name;
                }
                return [2 /*return*/];
            });
        }); });
    };
    ApplicationComponent.prototype.reUploadPassport = function (base64) {
        var _this = this;
        var formData = new FormData();
        formData.append("upload_file_passport", base64);
        this.rest.uploadPassportFile(formData).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.person.imgPassName = result.name;
                return [2 /*return*/];
            });
        }); });
    };
    ApplicationComponent.prototype.clickCheckSurname = function () {
        var _this = this;
        if (this.personForm.invalid) {
            this.personForm.markAllAsTouched();
            this.scrollToFirstInvalidControl();
        }
        if (this.person.lastName === "".trim() &&
            this.acceptTerm === true &&
            this.personForm.valid) {
            Swal.fire({
                title: "<h6>" + this.popUpMessageHeader + "</h6>",
                input: "checkbox",
                showCancelButton: true,
                inputPlaceholder: "\n            " + this.popUpMessageBody + "\n          ",
                confirmButtonText: "\n            " + this.popUpMessageSubmit + "\n          ",
                customClass: {
                    input: "check-box",
                },
                cancelButtonText: "" + this.popUpMessageEdit,
                inputValidator: function (result) {
                    if (!result) {
                        return !result && "" + _this.popUpMessageAlert;
                    }
                    else {
                        _this.checkDuplicate();
                    }
                },
            });
        }
        else {
            this.checkDuplicate();
        }
    };
    ApplicationComponent.prototype.onLoadFaceProcessing = function () {
        var fpctext = this.localStorage.getItem("faceProcessing");
        if (fpctext) {
            var faceprocess = JSON.parse(fpctext);
            this.faceProccessing = faceprocess;
            this.localStorage.setItem("faceProcessing", JSON.stringify(faceprocess));
        }
        else {
            this.localStorage.setItem("faceProcessing", JSON.stringify(this.faceProccessing));
        }
    };
    ApplicationComponent.prototype.onSetFaceProcessing = function () {
        var fpctext = this.localStorage.getItem("faceProcessing");
        if (fpctext) {
            var faceprocess = JSON.parse(fpctext);
            var faceProccessing = tslib_1.__assign({}, faceprocess, this.faceProccessing);
            this.localStorage.setItem("faceProcessing", JSON.stringify(faceProccessing));
        }
        else {
            this.localStorage.setItem("faceProcessing", JSON.stringify(this.faceProccessing));
        }
    };
    ApplicationComponent.prototype.clearFaceProcessing = function () {
        this.localStorage.removeItem("faceProcessing");
        this.faceProccessing = {
            facePhotoDetect: false,
            facePassportDetect: false,
            faceMatch: false,
            faceMatchSimilar: 0,
            faceMatchMessage: "",
        };
        this.localStorage.setItem("faceProcessing", JSON.stringify(this.faceProccessing));
    };
    return ApplicationComponent;
}());
export { ApplicationComponent };
